import { render, staticRenderFns } from "./orderdeal.vue?vue&type=template&id=3005b8af&scoped=true&"
import script from "./orderdeal.vue?vue&type=script&lang=js&"
export * from "./orderdeal.vue?vue&type=script&lang=js&"
import style1 from "./orderdeal.vue?vue&type=style&index=1&id=3005b8af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3005b8af",
  null
  
)

export default component.exports